/* jshint esversion: 6, -W097 */
/* globals require */
(function(angular) {
    'use strict';
    var app = angular.module('enervee');

    app.directive('changePasswordModal', [function() {
        return {
            restrict: 'E',
            controller: [
                '$scope',
                'ChangePasswordService',
                'CmsContentService',
                'IndexService',
                'UtilService',
                function (
                    $scope,
                    ChangePasswordService,
                    CMSContentService,
                    IndexService,
                    UtilService
                ) {

                    $scope.passwordMinLength = UtilService.getSetting('passwordMinLength');
                    $scope.validateFormField = IndexService.validateFormField;

                    var changePasswordSuccessMessage;
                    var oldPasswordIncorrectMessage;

                    CMSContentService.getMarketPlaceText(
                       'base:modals:change_password_pwd_updated_msg'
                    ).then(function(text) {
                       changePasswordSuccessMessage = text;
                    });
                    CMSContentService.getMarketPlaceText(
                       'base:modals:change_password_old_password_incorrect_msg'
                   ).then(function(text) {
                       oldPasswordIncorrectMessage = text;
                   });
                   CMSContentService.getMarketPlaceText(
                       'base:modals:password_min_length_text',
                       {
                           min_length: $scope.passwordMinLength
                       }
                   ).then(function(text) {
                       $scope.passwordMinLengthError = text;
                   });


                    $scope.submitChangePasswordModal = function(oldPassword, newPassword1, newPassword2) {

                        ChangePasswordService.changePassword(oldPassword, newPassword1, newPassword2).then(function() {
                            var _passwordChangeResponse = ChangePasswordService.getChangePasswordResponse();
                            var fields = ['old_password', 'new_password1', 'new_password2'];
                            fields.forEach(function(field){
                                $scope.changePasswordForm[field].$invalid = false;
                                $scope.changePasswordForm[field].$error.message = '';
                            });
                            $scope.changePasswordForm.old_password.$error.invalid = false;

                            if (_passwordChangeResponse.success === true) {
                                var alerts = [{
                                    type: 'success',
                                    message: changePasswordSuccessMessage
                                }];

                                IndexService.setHeaderAlerts(alerts);

                                $scope.old_password = $scope.new_password1 = $scope.new_password2 = "";

                                IndexService.closeModal('#modal-change-password');
                            } else {

                                if ('old_password' in _passwordChangeResponse.error){
                                    $scope.changePasswordForm.old_password.$error.invalid = true;
                                    $scope.changePasswordForm.old_password.$invalid = true;
                                }
                                for (var error_key in _passwordChangeResponse.error) {
                                    $scope.changePasswordForm[error_key].$error.message = _passwordChangeResponse.error[error_key].toString();
                                    $scope.changePasswordForm[error_key].$invalid = true;
                                }

                            }

                        });
                    };
                }],
            template: require('@app/shared/modals/changePassword/changePasswordView.html'),
        };
    }]);

})(angular);
